export const GET_MY_THINK_CHATS_DATA_INIT = 'GET_MY_THINK_CHATS_DATA_INIT';
export const GET_MY_THINK_CHATS_DATA_SUCCESS = 'GET_MY_THINK_CHATS_DATA_SUCCESS';
export const GET_MY_THINK_CHATS_DATA_FAILURE = 'GET_MY_THINK_CHATS_DATA_FAILURE';

export const CHANGE_THINK_SEED_IMAGE_INIT = 'CHANGE_THINK_SEED_IMAGE_INIT';
export const CHANGE_THINK_SEED_IMAGE_SUCCESS = 'CHANGE_THINK_SEED_IMAGE_SUCCESS';
export const CHANGE_THINK_SEED_IMAGE_FAILURE = 'CHANGE_THINK_SEED_IMAGE_FAILURE';

export const LEAVE_THINK_CHAT = 'LEAVE_THINK_CHAT';
export const JOIN_THINK_CHAT = 'JOIN_THINK_CHAT';
export const UPDATE_THINK_CHAT = 'UPDATE_THINK_CHAT';


export const GET_NARRATIVES_THINK_CHATS_INIT = 'GET_NARRATIVES_THINK_CHATS_INIT';
export const GET_NARRATIVES_THINK_CHATS_SUCCESS = 'GET_NARRATIVES_THINK_CHATS_SUCCESS';
export const GET_NARRATIVES_THINK_CHATS_FAILURE = 'GET_NARRATIVES_THINK_CHATS_FAILURE';

export const GET_USER_NARRATIVES_THINK_CHATS_INIT = 'GET_USER_NARRATIVES_THINK_CHATS_INIT';
export const GET_USER_NARRATIVES_THINK_CHATS_SUCCESS = 'GET_USER_NARRATIVES_THINK_CHATS_SUCCESS';
export const GET_USER_NARRATIVES_THINK_CHATS_FAILURE = 'GET_USER_NARRATIVES_THINK_CHATS_FAILURE';

export const NOTIFICATION_TO_ROOM = 'notification to room';
export const NOTIFICATION = 'notification';



// WEBPACK FOOTER //
// ./src/modules/think-seeds/types.js